import { render, staticRenderFns } from "./AffiliateReferralSettings.vue?vue&type=template&id=53309c35&scoped=true"
import script from "./AffiliateReferralSettings.vue?vue&type=script&lang=js"
export * from "./AffiliateReferralSettings.vue?vue&type=script&lang=js"
import style0 from "./AffiliateReferralSettings.vue?vue&type=style&index=0&id=53309c35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53309c35",
  null
  
)

export default component.exports